module.exports = __webpack_public_path__ + "static/11-Early-Morning-View-a63f87e517619d955c9fba16d60f086d.jpg";